<template>
<!-- 메일패드 팝업 -->
<div class="modal fade" id="mail_comment" tabindex="-1" role="dialog" aria-labelledby="commentLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <a type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                <div style="width: 100%; padding: 50px 0; font-family: '맑은 고딕', 'Apple Gothic', 'malgun gothic', 'AppleGothic', 'Arial', 'Helvetica', sans-serif;">
                    <div style="width: 100%; max-width: 600px; margin: 0 auto;">
                        <div style="background: #f77924; width: 100%; height: 6px;"></div>
                        <div style="margin-top:20px;">
                            <!-- 적용할때 경로 꼭! 바꿔주세요!  -->
                            <span aria-hidden="true">
                                <!-- <img src="../../assets/img/close.png" alt="close" class="pointer close-btn"> -->
                            </span>
                            <img src="../../assets/img/logo.png" alt="carrotglobal" style="width: 130px;float:right;">

                        </div>
                        <div style="width: 100%; background: #ffffff;margin: 20px 0 40px 0;">
                            <div style="font-size: 14px; line-height: 22px; letter-spacing: -1px;padding: 20px 30px 40px 30px;">
                                <p style="font-weight: bold; font-size: 22px;margin-top:10px; margin-bottom: 20px;">{{mailPadData.sugang_name}} 문의사항 안내 드립니다.</p>

                                안녕하세요. {{mailPadData.name}}님!<br>
                                아래 문의 주신 내용에 대해 답변 드립니다.<br>

                                <p style="background:#C8C8C8; padding: 10px; margin:20px 0px;">{{mailPadData.qa_contents}}</p>

                                {{mailPadData.asContents}} <br><br>

                                감사합니다. <br>
                                {{mailPadData.managerName}} 매니저 드림.
                            </div>
                        </div>
                        <div style="width: 100%; max-width: 650px; margin: 0 auto; text-align:center; background:#303030; color:#afafaf; font-size:14px; padding:10px 0;">
                            <p style="-webkit-margin-before: 0em; -webkit-margin-after: 0em; line-height:20px; margin:0;">
                                <span style="font-weight: bold; color: #fff;">과정문의</span>
                                {{mailPadData.managerName}} 매니저 │ {{mailPadData.email}}
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['parentData'],
    data: () => ({
        mailPadData: {}, // 메일패드 api호출할 데이터
        qaIdx: '' // 1:1 문의 고유 idx
    }),

    mounted() {
        this.mailPadData = this.parentData
        console.log('this.mailPadData', this.mailPadData)
        this.qaIdx = this.mailPadData.qaIdx
        var params = this.mailPadData

        // this.axios.get(this.axios.root + this.axios.port + `/admin/as/mail/${this.qaIdx}`, {
        //     params: params
        // }).then(res => {
        //     console.log('res', res)
        //     if (res.data.err === 0) {

        //     } else {
        //         alert(res.data.err)
        //     }
        // }).catch(err => {
        //     console.log(err)
        //     alert(err)
        // })
    }
}
</script>
